import { Button } from "primereact/button";
import { getSocket } from '../context/socket'; // adjust the path if needed

const ArchivePopup = ({ onCancel, cardDetails, togglePopup, cardId, boardId }) => {
    const socket = getSocket();

    const handleArchiveCard = () => {
        if (!cardDetails || !cardDetails.card_id) return;
        console.log("📡 Emitting toggleCardActiveStatus with card_id:", cardDetails.board_id);
        socket.emit("toggleCardActiveStatus", {
            card_id: cardId,
            is_active: false, // false = archived
            board_id: boardId
        });

        togglePopup("archive"); // Close popup after action
    };

    return (
        <div className="popup-box popup-archive">
            <div className="popup-header">
                Archive
                <Button
                    icon="pi pi-times"
                    className="p-button-text close-btn"
                    onClick={onCancel}
                />
            </div>
            <div className="popup-body">
                <p>Are you sure you want to archive this card?</p>
                <div className="d-flex justify-content-end mt-1">
                    <Button
                        label="Cancel"
                        severity="secondary"
                        className="border-0 py-1 px-3 mt-1 me-2"
                        onClick={onCancel}
                    />
                    <Button
                        label="Archive"
                        severity="danger"
                        className="border-0 py-1 px-3 mt-1 me-2"
                        onClick={handleArchiveCard}
                    />
                </div>
            </div>
        </div>
    );
};

export default ArchivePopup;
